import { DirectionsCar as IconCar, Home as IconHome } from "@mui/icons-material";
import { Divider, Stack, Typography } from "@mui/material";

import { formatTime } from "~/modules/app/util/formatters";

type NextShiftTimeInfo = {
    startAt: Date;
    endAt: Date;
};

export default function NextShiftTimeInfo({ startAt, endAt }: NextShiftTimeInfo) {
    return (
        <Stack alignItems="center" direction="row" display="flex" columnGap={1}>
            <Stack display="flex" direction="row" justifyContent="flex-start" columnGap={1}>
                <IconCar />
                <Typography>{formatTime(startAt)}</Typography>
            </Stack>
            <Divider orientation="horizontal" sx={{ flexGrow: 2, borderStyle: "dashed" }} />
            <Stack display="flex" direction="row" justifyContent="flex-end" columnGap={1}>
                <IconHome />
                {formatTime(endAt)}
            </Stack>
        </Stack>
    );
}
